import { ToolManagamentRebuildOption } from './tool-managament-rebuild-option';

export class ToolManagament {
  constructor(
    public hash?: string,
    public name?: string,
    public erp?: string,
    public stockNumber?: number,
    public toStoreCounter?: number,
    public inUseCounter?: number,
    public toRebuildCounter?: number,
    public toValidateCounter?: number,
    public toErpCounter?: number,
    public toRebuildThisToolCounter?: number,
    public orderQuantity?: number,
    public requestQuantity?: number,
    public isToolPublic?: boolean,
    public isToolHolderPublic?: boolean,
    public categoryName?: string,
    public restockError?: string,
    public options?: ToolManagamentRebuildOption[]
  ) { }

  get stockNumberOrZero(): number {
    return this.stockNumber || 0;
  }

  get toStoreCounterOrZero(): number {
    return this.toStoreCounter || 0;
  }

  get inUseCounterOrZero(): number {
    return this.inUseCounter || 0;
  }

  get toRebuildCounterOrZero(): number {
    return this.toRebuildCounter || 0;
  }

  get toValidateCounterOrZero(): number {
    return this.toValidateCounter || 0;
  }

  get toErpCounterOrZero(): number {
    return this.toErpCounter || 0;
  }

  get toRebuildThisToolCounterOrZero(): number {
    return this.toRebuildThisToolCounter || 0;
  }

  clone() {
    return new ToolManagament(
      this.hash,
      this.name,
      this.erp,
      this.stockNumber,
      this.toStoreCounter,
      this.inUseCounter,
      this.toRebuildCounter,
      this.toValidateCounter,
      this.toErpCounter,
      this.toRebuildThisToolCounter,
      this.orderQuantity,
      this.requestQuantity,
      this.isToolPublic,
      this.isToolHolderPublic,
      this.categoryName,
      this.restockError,
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-managament.ts